import { toLatinDigits } from './numbers';

/**
 * 🔴 ONE WAY TO COMPARE WHAT WAS TYPED WITH WHAT IS LISTED — design-system plan DS-5 (7.2; F433, F216, F609).
 *
 * The palette lower-cased and the till compared codes exactly, so `রহমান` typed on one keyboard missed `রহমান` stored
 * from another. `foldSearch` brings both sides to one form, and is applied to the index and the query alike:
 *
 * - Unicode NFC. The precomposed nukta letters য় ড় ঢ় (U+09DF, U+09DC, U+09DD) are composition exclusions, so NFC
 *   writes them as base + nukta — the form most keyboards type — and the two spellings meet;
 * - the Bengali digits ০–৯ become 0–9, so `১২০` finds item 120;
 * - the zero-width joiner and non-joiner (U+200D, U+200C), which change a conjunct's shape and not its meaning, go;
 * - Latin letters are case-folded, and runs of white space become one space.
 */
export function foldSearch(text: string): string {
  return toLatinDigits(text.normalize('NFC'))
    .replace(/[‌‍]/g, '')
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .trim();
}

/** Whether `haystack` contains `query`, both folded. An empty query matches everything. */
export function matchesSearch(haystack: string, query: string): boolean {
  const q = foldSearch(query);
  return q === '' || foldSearch(haystack).includes(q);
}
